export default __webpack_public_path__ + "static/media/VIP_black.46c2d58b.png";